import {PESODEFOULT} from "../Constantes";

export const obtenerPesoTotal = (productos) =>{

  // console.log(productos);
    //recibe gramos
    let peso  =productos.reduce((acumulador, producto) => {
        const peso = producto.peso || PESODEFOULT;
        const cantidad = producto.cantidad || 1;
        return acumulador + (peso * cantidad);
    }, 0)

    //devuelve kilos
    if (peso > 1){
        return 1
    }else{
        return peso.toFixed(2);
    }
}